export const catalog_matrix = [
    {form_key:'responsible_id', catalog_key:'none', propname:'users'},
    {form_key:'client_attention_info_1_id', catalog_key:'client_attention_info'},
    {form_key:'client_attention_info_2_id', catalog_key:'client_attention_info'},
]